var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:`text-none py-6 px-8 ${_vm.textColor}`,attrs:{"color":_vm.color,"depressed":"","tile":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }